import React, { useEffect, useState } from 'react';
import '../../../styles/admin/AdminTable.css';

const BASE = process.env.REACT_APP_API_URL || ''; // 안전: 미설정 시 상대경로

function InfluencerInquiryList({ onSelect, selectedId, interactive = true, refreshToken }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const fetchList = async () => {
    setLoading(true); setError('');
    try {
      const url = `${BASE}/api/influencer/inquiry?role=influencer`;
      const res = await fetch(url, { credentials: 'include' });

      // HTML 응답(예: 리다이렉트/오류) 방지: 헤더 검사
      const ct = res.headers.get('content-type') || '';
      let data = null;
      if (ct.includes('application/json')) {
        data = await res.json().catch(() => ({}));
      } else {
        await res.text(); // 내용은 사용하지 않음
        if (res.status === 401 || res.status === 403) throw new Error('관리자 인증이 필요합니다.');
        throw new Error(`서버 응답 형식 오류(${res.status}).`);
      }

      if (!res.ok || !data?.ok) {
        throw new Error(data?.message || `불러오기 실패(${res.status})`);
      }
      setItems(data.items || []);
    } catch (e) {
      setError(e.message || '불러오기 실패');
      setItems([]);
    }
    setLoading(false);
  };

  useEffect(() => { fetchList(); }, [refreshToken]);

  const fmt = (ts) => ts ? new Date(ts).toLocaleString() : '';

  return (
    <div className="admin-list">
      <div className="admin-list__header">문의하기 내역(인플루언서)</div>
      
      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && <div className="admin-list__empty">문의 내역이 없습니다.</div>}
        
        {!loading && items.length > 0 && (
          <div>
            {items.map((u, i) => (
              <div
                key={u._id || i}
                onClick={interactive && onSelect ? () => onSelect(u) : undefined}
                className={`admin-list__item ${
                  selectedId && (selectedId === (u._id || `${u.ownerUserId}-${u.createdAt}`)) ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {u.ownerUserId} ({u.ownerUserName})
                  </div>
                  <div className="admin-list__item-sub">{fmt(u.createdAt)}</div>
                </div>
                <div className="admin-list__item-meta">
                  상태: <span className={`admin-list__item-badge ${u.status === 'done' ? 'admin-list__item-badge--success' : 'admin-list__item-badge--warning'}`}>
                    {u.status === 'done' ? '완료' : '대기'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerInquiryList;
